var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLegendSosResolved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6405_466490)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00884A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 25.1667V21H16.5202V25.1667H15.4785ZM23.3691 22.0958L20.4124 19.1651L21.1556 18.4219L24.0863 21.3786L23.3691 22.0958ZM8.62956 22.0958L7.91237 21.3786L10.8431 18.4219L11.5863 19.1651L8.62956 22.0958ZM8.70768 9.54167V10.7435C8.70768 10.9305 8.76775 11.0841 8.88789 11.2044C9.0082 11.3246 9.16185 11.3846 9.34883 11.3846H22.6499C22.8369 11.3846 22.9905 11.3246 23.1108 11.2044C23.2309 11.0841 23.291 10.9305 23.291 10.7435V9.54167H8.70768ZM11.3358 12.4263L11.8488 13.8484C11.9021 13.9821 11.9822 14.0857 12.0892 14.1591C12.196 14.2326 12.3161 14.2693 12.4496 14.2693H19.5491C19.6826 14.2693 19.8027 14.2326 19.9095 14.1591C20.0165 14.0857 20.0966 13.9821 20.1499 13.8484L20.6629 12.4263H11.3358ZM12.4496 15.3109C12.0918 15.3109 11.7673 15.2097 11.4762 15.0073C11.185 14.805 10.9767 14.5337 10.8512 14.1932L10.2301 12.4263H9.34883C8.88268 12.4263 8.48563 12.2623 8.15768 11.9344C7.8299 11.6066 7.66602 11.2096 7.66602 10.7435V8.5H24.3327V10.7435C24.3327 11.2096 24.1688 11.6066 23.841 11.9344C23.5131 12.2623 23.116 12.4263 22.6499 12.4263H21.7686L21.0715 14.2172C20.942 14.5363 20.7369 14.7983 20.4564 15.0034C20.176 15.2084 19.8589 15.3109 19.5051 15.3109H12.4496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6405_466490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLegendSosResolved);
export default __webpack_public_path__ + "static/media/map-legend-sos-resolved.024e3b7e9bcb1739045ab46711a567bd.svg";
export { ForwardRef as ReactComponent };